import { SubmitHandler } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { NewUserStep2 } from '~api/models'
import * as wizardNewUserActions from '~store/wizardNewUser/actions'
import { OnBack, StepProps } from '~shared/components/reactHookForm/MultiStepForm/useMultiStepForm'

import Step2Form from './Step2Form'
import { NewUserStep2Schema } from './Step2.schema'

type Step2Hook = () => StepProps<NewUserStep2>

export interface NewUserStep2Extended extends NewUserStep2 {
  acceptPrivacyPolicy: boolean
}

export const useStep2: Step2Hook = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onSubmit: SubmitHandler<NewUserStep2Extended> = (formValues): void => {
    const { acceptPrivacyPolicy, ...rest } = formValues
    const cleanedFormValues: NewUserStep2 = rest

    if (acceptPrivacyPolicy) {
      dispatch(wizardNewUserActions.updateFormStepValuesAndSubmit({ step: 'step2', values: cleanedFormValues }))
    }
  }

  const onBack: OnBack<NewUserStep2Extended> = (formValues) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- remove helper values
    const { acceptPrivacyPolicy, ...rest } = formValues
    const cleanedFormValues: NewUserStep2 = rest

    dispatch(wizardNewUserActions.updateFormStepValues({ step: 'step2', values: cleanedFormValues }))
  }

  return {
    onSubmit,
    onBack,
    component: Step2Form,
    validationSchema: NewUserStep2Schema,
    label: t('form:newUserFormStep2Label'),
  }
}
